export const isPricingPositionComplete = (schemaType: string | undefined, entity: any): boolean => {
  if (!entity) return false;
  switch (schemaType) {
    case 'veengu_fee_default':
    case 'veengu_tax_default':
    case 'veengu_fee_membership':
    case 'veengu_fee_acquiring':
      return Boolean(entity.type);
    case 'veengu_fee_loyalty_default':
      return Boolean(entity.discountType);
    case 'veengu_limit_default_amount':
    case 'veengu_limit_single_operation_amount':
      return entity.amount != null;
    default:
      return false;
  }
};
